import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChatParkingResultCard, RuleActionExtension } from '@sabstravtech/obtservices/base';
import { faCar } from '@fortawesome/free-solid-svg-icons';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { formatCardCurrency, policyStatusClass, policyStatusLabel } from '../chat-card.util';

@Component({
  selector: 'app-chat-parking-card',
  standalone: false,
  templateUrl: './chat-parking-card.component.html',
  styleUrls: ['./chat-parking-card.component.scss']
})
export class ChatParkingCardComponent {
  @Input() card!: ChatParkingResultCard;
  @Output() cardClick = new EventEmitter<void>();

  // ENT-16273: mockup shows a car icon by the name and a clock icon on the transfer line.
  readonly faCar = faCar;
  readonly faClock = faClock;

  get policyClass(): string {
    return policyStatusClass(this.card.policyStatus);
  }

  get policyLabel(): string {
    return policyStatusLabel(this.policyClass);
  }

  /** This quote's policy fields, shaped for `app-warning-tags` — the same
   *  indicator/tooltip component the results page uses, so the chat card and
   *  results page render identically instead of a bespoke text box. */
  get headlineWarningTicket(): RuleActionExtension {
    return {
      unavailable: !!this.card.unavailable,
      unavailableMessage: this.card.unavailableMessage || '',
      requiresReasonKeys: this.card.requiresReasonKeys || [],
      requiresReasonMessages: this.card.requiresReasonMessages || []
    };
  }

  /** Select the card unless the quote is out of policy and disallowed. */
  onCardClick(): void {
    if (this.card.unavailable) return;
    this.cardClick.emit();
  }

  get formattedPrice(): string {
    if (this.card.unavailable) {
      return '';
    }
    return formatCardCurrency(this.card.price, this.card.currency || 'GBP');
  }
}
